<script setup lang="ts">
defineOptions({
  name: "VSectionLabel",
});

/** The small uppercase label above a group of fields ("Nieuwe meldingen", "Wat mag de gast", "Blokkades"). */
const { as = "div" } = defineProps<{
  as?: "div" | "span" | "h2" | "h3" | "h4" | "legend"
}>();

defineSlots<{
  default?: () => unknown
}>();
</script>

<template>
  <component :is="as" class="m-0 text-xs font-bold uppercase tracking-[0.06em] text-gray-700 dark:text-gray-400">
    <slot />
  </component>
</template>
